export const toggleFavouriteImage = image => ({
    type: "TOGGLE_FAVOURITE_IMAGE",
    payload: image
})




